import React from "react";
import classNames from "classnames";
import { Manager, Target, Popper } from "react-popper";
import {
  withStyles,
  IconButton,
  MenuItem,
  MenuList,
  Grow,
  Paper,
  ClickAwayListener,
  Button,
  Hidden
} from "@material-ui/core";


import Person from "@material-ui/icons/Person"
import Notifications from "@material-ui/icons/Notifications"
import Dashboard from "@material-ui/icons/Dashboard"
import Search from "@material-ui/icons/Search"



import { CustomInput, IconButton as SearchButton,OrganisationSelector } from "../../components";

import headerLinksStyle from "../../assets/jss/material-dashboard-react/headerLinksStyle";

class HeaderLinks extends React.Component {
  state = {
    open: false
  };


  handleClick = () => {
    this.setState({ open: this.state.open?false:true});
  };

  render() {

    const {  classes, logout , userOrganisations, profile , selectOrganisationCallback } = this.props;

    const { open } = this.state;

    return (
      <div className={classes.container}>  
            <div style={{marginRight:80}}  onClick={()=>{this.handleClick()}}>
            <OrganisationSelector  open={open} selected={selectOrganisationCallback} organisations={userOrganisations} selectedOrganisation={profile&&profile.selectedOrganisation}/>
             </div>     
          <Button onClick={()=>{logout()}} variant="flat">
            LOGOUT
        </Button>

      </div>
    );
  }
}

const styles={
  container:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"flex-start"
  },
}

export default withStyles(styles)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx